const SquareBox: React.FC= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <rect x='5' y='5' width='90' height='90'
      />
    </svg>
  )
}

export default SquareBox